<script>
import draggable from 'vuedraggable';

export default {
    components: {
        draggable,
    },
    props: {
        field: {
            type: Object,
            default: () => {},
        },
        value: {
            type: [String, Number, Boolean, Array, Object],
            default: null,
        },
    },
    computed: {
        fieldValue: {
            get() {
                if (Array.isArray(this.value)) {
                    return [...this.value];
                }

                return [];
            },
            set(field) {
                this.$emit('input', field);
            },
        },
        columns() {
            return this.field.options?.options ?? [];
        },
    },
    methods: {
        addRow() {
            const value = this.fieldValue;
            value.push({});
            this.fieldValue = value;
        },
        updateColumn(rowIndex, column, value) {
            this.$store.dispatch('document/updateTableColumn', {
                field: this.field,
                rowIndex,
                column,
                value,
            });
        },
    },
};
</script>

<template>
    <div>
        <table
            v-if="columns"
            class="table"
        >
            <thead>
                <tr>
                    <th
                        v-for="(column, index) in columns"
                        :key="index"
                    >
                        {{ column }}
                    </th>
                </tr>
            </thead>
            <draggable
                v-model="fieldValue"
                tag="tbody"
            >
                <tr
                    v-for="(row, rowIndex) in fieldValue"
                    :key="rowIndex"
                >
                    <td
                        v-for="(column, columnIndex) in columns"
                        :key="columnIndex"
                    >
                        <b-form-input
                            :value="row[column]"
                            type="text"
                            @input="updateColumn(rowIndex, column, $event)"
                        />
                    </td>
                </tr>
            </draggable>
        </table>

        <b-button
            type="button"
            variant="primary"
            size="xs"
            @click="addRow"
        >
            Add row
        </b-button>
    </div>
</template>

<style
    scoped
    lang="scss"
>

</style>
